import React from 'react';
import PrivacyPolicyHero from '../../components/sections/PrivacyPolicyHero';

const PrivacyPolicy = () => {
    
    return(
        <>
      <PrivacyPolicyHero />
      </>
    )
}

export default PrivacyPolicy